import {extend} from 'umi-request'
import {message} from 'antd'
import {history} from 'umi'
import progressMiddleware from 'umi-request-progress'

const baseUrl = STREAMS_API_URL
const request = extend({
  prefix: baseUrl,
  timeout: 300000,
  headers: {
    Authorization: null
  }
})

request.use(progressMiddleware, {core: true})
request.interceptors.request.use((url, options) => {
  const user = JSON.parse(localStorage.getItem('current_user') || 'null')
  const token = user?.token || localStorage.getItem('auth_token')
  const headers = token ? {Authorization: `Bearer ${token}`} : {}

  return {
    url: url,
    options: {
      ...options,
      headers
    }
  }
})

request.interceptors.response.use(async (response, options) => {
  if (response?.status === 401) {
    localStorage.removeItem('current_user')
    localStorage.removeItem('auth_token')
    message.open({
      key: 'authenticate',
      type: 'warning',
      content: '请重新登录',
      duration: 5
    })

    history.push('/login')
  }
  else if (response?.status === 403) {
    localStorage.removeItem('current_user')
    localStorage.removeItem('auth_token')
    message.open({
      key: 'authenticate',
      type: 'error',
      content: '没有权限',
      duration: 5
    })

    history.push('/403')
  }
  else if (response?.status >= 400) {
    const data = await response.clone().json()
    message.error(data?.message, 5)
    throw new Error(data.message)
  }

  return response
})

export default request
